module.exports = "/_next/static/images/window_restore-1a47438cf7372e615a6916f980f5466a.svg";